import {
  localStore,
  isLocalStorageAvailable,
  CookieCategory,
} from '@moonpig/web-core-browser-storage'
import { DateTime } from 'luxon'

export const trySetLocalStorageWithExpiry = (
  key: string,
  value: string,
  category: CookieCategory,
) => {
  try {
    const expiryDate = DateTime.now().plus({ days: 3 }).toISO()
    localStore.setItem(`${key}_exp`, expiryDate, category)
    localStore.setItem(key, value, category)
  } catch {
    /* empty */
  }
}

const getExpiryDateByKey = (key: string) => {
  const expiryDateItem = localStore.tryGetItem(`${key}_exp`)
  return expiryDateItem ? DateTime.fromISO(expiryDateItem) : null
}

const isNotExpired = (expiryDate: DateTime) => {
  const currentDate = DateTime.now()
  return DateTime.min(currentDate, expiryDate).equals(currentDate)
}

const removeLocalStorageItemWithExpiryByKey = (key: string) => {
  localStore.tryRemoveItem(`${key}_exp`)
  localStore.tryRemoveItem(key)
}

export const tryGetLocalStorageWithExpiry = (key: string) => {
  try {
    if (isLocalStorageAvailable()) {
      const expiryDate = getExpiryDateByKey(key)

      if (expiryDate && isNotExpired(expiryDate)) {
        return localStore.getItem(key)
      }

      removeLocalStorageItemWithExpiryByKey(key)

      return null
    }
    throw new Error('Local storage is not available')
  } catch {
    return null
  }
}
